






import { Component, Vue } from 'vue-property-decorator';
import Presentational from './presentational.vue';
import { FirebaseModule } from '@/module/firebase';

@Component({
  components: { Presentational },
})
export default class GlobalHeaderContainer extends Vue {
  private firebaseModule = new FirebaseModule();

  public signOut() {
    this.firebaseModule.logout();
  }
}
